import { useState } from "react";

/** Centralises the api-error state pattern shared across all form views. */
export const useApiError = () => {
  const [apiError, setApiError] = useState<string | null>(null);
  const clearError = () => setApiError(null);
  return { apiError, setApiError, clearError };
};
